export default build =>
    build.mutation({
        query(payload) {
            console.log("payload",payload)
            return {
                url: '/exam/createtaluka',
                method: 'POST',
                body: payload,
               
            };
        },
        invalidatesTags: ['allTalukas'],
    })
